// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"163":"21b4304e","252":"6d30d94b"}[chunkId] + ".css";
};